import invariant from 'invariant';
import type { Project } from '@frameio/graphql-client/generated';
import { createUrl } from '../helpers/createUrl';
import { getPathnameFromHref } from '../helpers/getPathnameFromHref';
import type { ValidHref } from '../types';

// @todo (WEB-1045): Remove when condensed UUID support is added to routes
const toCondensedUUID = (uuid: string): string => uuid;

/**
 * AllCollectionsPage
 *
 * /project/:projectId/collections
 */
export type AllCollectionsGetLinkParams = {
  page: 'allCollections';
  projectId: Project['id'];
};

export const getLinkForAllCollections = (
  params: AllCollectionsGetLinkParams
): ValidHref => {
  // Assert required params for better error messages
  invariant(params.projectId, 'projectId is required');
  const projectId = toCondensedUUID(params.projectId);

  if (params.page === 'allCollections') {
    return createUrl({
      pathname: `/project/${projectId}/collections`,
    });
  }

  throw new Error('Not implemented');
};

export const isAllCollectionsPageType = (href: ValidHref): boolean => {
  const pathname = getPathnameFromHref(href);
  const parts = pathname.split('/');

  // /project/:projectId/collections
  return parts[1] === 'project' && parts[3] === 'collections';
};
